<div>
    <!--  <ariadna-alert [classes]="'bottom-full-width'"></ariadna-alert>-->
    <router-outlet></router-outlet>
    <ariadna-alert
        appAlertRenderDirective
        [classes]="'top-right'"
    ></ariadna-alert>
</div>
